/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getReceivedInvitationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "organizationLogoUrl": zod.string().nullish(),
  "email": zod.string(),
  "role": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "expiryDate": zod.string().datetime({}),
  "isExpired": zod.boolean(),
  "acceptedDate": zod.string().datetime({}).nullish(),
  "isAccepted": zod.boolean(),
  "isActive": zod.boolean(),
  "invitedByUserFullName": zod.string().nullish()
})),
  "count": zod.number()
})

export const getInvitationDetailsParams = zod.object({
  "token": zod.string()
})

export const getInvitationDetailsResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "organizationLogoUrl": zod.string().nullish(),
  "email": zod.string(),
  "role": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "expiryDate": zod.string().datetime({}),
  "isExpired": zod.boolean(),
  "acceptedDate": zod.string().datetime({}).nullish(),
  "isAccepted": zod.boolean(),
  "isActive": zod.boolean(),
  "invitedByUserFullName": zod.string().nullish()
})

export const acceptInvitationByTokenParams = zod.object({
  "token": zod.string()
})

export const acceptInvitationByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const declineInvitationByIdParams = zod.object({
  "id": zod.string().uuid()
})

